const  StorageService = {
  store: (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
  },

  get: key => {
    return localStorage.getItem(key);
  },

  remove: key => {
    localStorage.removeItem(key);
  },

  clear: () => {
    localStorage.clear();
  },

  storeForSession: (key, value) => {
    sessionStorage.setItem(key, JSON.stringify(value));
  },

  removeFromSession: key => {
    sessionStorage.removeItem(key);
  },

  getFromSession: key => {
    return JSON.parse(sessionStorage.getItem(key) || 'null');
  },
};

export default StorageService;
